import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-process',
  templateUrl: './about-process.component.html',
  styleUrls: ['./about-process.component.css']
})
export class AboutProcessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
